import { PointageJournalier } from '../../domain/RH/pointage-journalier';
import { PointagePause } from '../../domain/RH/pointage-pause';
import { mapper } from '../../tools/mapping/mapper';
import { PointageJournalierEntity, PointagePauseEntity } from '../entity';
import type { AppDB } from '../db';

export class PointageRepository {
    constructor(private readonly database: AppDB) {}


    async getPointageJournalierEntityById(id: number) {
        return await this.database.pointageJournaliers.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async addPointageJournalier(pointage: PointageJournalier) {

        const pje = mapper.map(pointage, PointageJournalier, PointageJournalierEntity);

        const pointageJournalierId = await this.database.pointageJournaliers.add(pje);

        if (pointage.PointagePauseList && pointage.PointagePauseList.length > 0) {
            for (let i = 0; i < pointage.PointagePauseList.length; i++) {
                await this.database.attachPointagePause(pointage.PointagePauseList[i], pointageJournalierId);
            }
        }

        return pointageJournalierId;
    }

    async attachPointagePause(pause: PointagePause, pointageJournalierId: number) {

        const ppe = mapper.map(pause, PointagePause, PointagePauseEntity);
        const pe = await this.database.getPointageJournalierEntityById(pointageJournalierId);
        const pointagePauseId = await this.database.pointagePauses.add(ppe);
        await this.database.pointageJournaliers.update(pointageJournalierId, {
            PointagePauseIds: pe?.PointagePauseIds ? [...pe.PointagePauseIds, pointagePauseId] : [pointagePauseId]
        });

        return pointagePauseId;
    }
}
